import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import { Table, Row, Col, CardBody } from "reactstrap";
import { DefaultColumnFilter } from "./filters";
import { ContactsGlobalFilter } from "./GlobalSearchFilter";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isUsersFilter,
  handleUserClick,
  HeaderTable,
}) {

  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <CardBody className="border border-dashed border-end-0 border-start-0">
        <form>
          <Row className="g-3">
          <Col lg={3} className="search-box me-2 mb-2">
              <input
                onChange={(e) => {
                  setValue(e.target.value);
                  onChange(e.target.value);
                }}
                id="search-bar-0"
                type="text"
                className="form-control search"
                placeholder={t("global.search_placeholder")}
                value={value || ""}
                style={{ borderRadius: "20px", backgroundColor: "#F6F6F6", fontSize: "12px", fontFamily:'Inter'}}
              />
              <i className="search-icon">
                <FontAwesomeIcon icon={faSearch} />
              </i>
            </Col>

            {isUsersFilter && (
              <Col lg={2}>
                <ContactsGlobalFilter />
              </Col>
            )}
            <Col>{/* <HeaderTable/> */}</Col>
          </Row>
        </form>
      </CardBody>
    </React.Fragment>
  );
}

const TableContainerMin = ({
  columns,
  data,
  isGlobalSearch,
  isGlobalFilter,
  isUsersFilter,
  handleUserClick,
  customPageSize,
  tableClass,
  theadClass,
  trClass,
  thClass,
  divClass,
  HeaderTable,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        selectedRowIds: 0,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };
  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };
  const { t } = useTranslation();
  return (
    <Fragment>
      <Row className="mb-3">
        {isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            isUsersFilter={isUsersFilter}
            handleUserClick={handleUserClick}
            HeaderTable={HeaderTable}
          />
        )}
      </Row>
      <div className={divClass}>
        <Table hover {...getTableProps()} className={tableClass}>
          <thead className={theadClass}>
            {headerGroups.map((headerGroup) => (
              <tr
                className={trClass}
                key={headerGroup.id}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column) => (
                  <th
                    key={column.id}
                    className={thClass}
                    {...column.getSortByToggleProps()}
                  >
                    {column.render("Header")}
                    {generateSortingIndicator(column)}
                    {/* <Filter column={column} /> */}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr>
                    {row.cells.map((cell) => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>

      <Row className="align-items-center mt-2 g-3 text-center text-sm-start">
        <div className="col-sm">
          <div className="text-muted" style={{color:'#434343',fontFamily:'Inter',fontSize:'14px'}} >  {t("table.display")}
            <span className="fw-semibold ms-1">{page.length}</span> {t("global.on")}{" "}
            <span className="fw-semibold">{data.length}</span> {t("global.results")}
          </div>
        </div>
        {isGlobalSearch && (
          <Col md={2} >
            <select
              className="form-select"
              value={pageSize}
              onChange={onChangeInSelect}
            >
              {[10, 20, 30, 40, 50].map((pageSize) => (
                <option key={pageSize} value={pageSize} >
                      {t("global.page")}    {pageSize}
                </option>
              ))}
            </select>
          </Col>
        )}

        <div className="col-sm-auto">
          <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
            <li
              className={!canPreviousPage ? "page-item disabled" : "page-item"}
            >
              <Link style={{color:'#434343',fontFamily:'Inter',fontSize:'14px'}}   to="#" className="page-link" onClick={previousPage}>
                  {t("global.pagination.previous")}
              </Link>
            </li>
            {pageOptions.map((item, key) => (
              <React.Fragment key={key}>
                <li className="page-item">
                  <Link
                    to="#"
                    className={
                      pageIndex === item ? "page-link active" : "page-link"
                    }
                    onClick={() => gotoPage(item)}
                  >
                    {item + 1}
                  </Link>
                </li>
              </React.Fragment>
            ))}
            <li className={!canNextPage ? "page-item disabled" : "page-item"}>
              <Link style={{color:'#434343',fontFamily:'Inter',fontSize:'14px'}}  to="#" className="page-link" onClick={nextPage}>
                  {t("global.pagination.next")}
              </Link>
            </li>
          </ul>
        </div>
      </Row>
    </Fragment>
  );
};

TableContainerMin.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainerMin;
